import PolicyLayout from "@/components/PolicyLayout";

export default function ReturnPolicyPage() {
  return (
    <PolicyLayout title="Return Policy">
      <p>
        We want you to be happy with your Pickle Wall™. If something isn't right
        with your order — it arrived damaged, defective, or incorrect — contact
        us and we'll work with you directly to make it right.
      </p>
      <p>
        Our detailed return window, condition requirements, and refund process
        are currently being finalized and will be published here. Until then,
        every return or exchange request is handled individually — email us with
        your order number and we'll walk you through it.
      </p>
    </PolicyLayout>
  );
}
